import CurrencyConversion from "../../Functions/Currency";
export default {
  computed: {
    allMemberLevels: function() {
      return this.$store.state.MembershipSettingStore.all_membership_settings;
    },
    allBeneficiaries: function() {
      let dupBen = this.$store.state.MemberStore.beneficiaries;
      var result = dupBen.reduce((unique, o) => {
        if (
          !unique.some(
            obj =>
              obj.first_name === o.first_name && obj.last_name === o.last_name
          )
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      return result;
    },
    allMemberTypes: function() {
      return this.$store.state.MemberTypeStore.all_member_types;
    },
    allMemberSettings: function() {
      var allSetting = this.$store.state.MembershipSettingStore
        .all_membership_settings;
      allSetting.map(function(setting) {
        var customName = {
          custom_name:
            setting.name +
            " - " +
            setting.membership_type +
            " (" +
            setting.residence +
            ")"
        };
        Object.assign(setting, customName);
      });
      return allSetting;
    },
    allGreenMemberSettings: function() {
      var allSetting = this.$store.state.MembershipSettingStore
        .all_green_membership_settings;
      allSetting.map(function(setting) {
        var customName = {
          custom_name:
            setting.name +
            " - " +
            setting.membership_type +
            " (" +
            setting.residence +
            ")"
        };
        Object.assign(setting, customName);
      });
      return allSetting;
    },
    memberSettingsGrouped: function() {
      // var array = []
      this.allMemberSettings.map(function(member) {});
    },
    memberTotal: function() {
      var total = this.convert1("KES", this.selectedSetting.price).amount;
      this.allBeneficiaries.map(function(beneficiary) {
        total = total + beneficiary.amount;
      });
      if (isNaN(total) === true) {
        return 0;
      } else {
        return total;
      }
    },
    allHouseHoldTypes: function() {
      return this.$store.state.HouseHoldStore.all_house_holds;
    },
    allResidenceTypes: function() {
      return this.$store.state.HouseHoldStore.all_house_holds;
    },
    selectedSetting: function() {
      if (this.$route.name === 'NewMembershipPayment') {
        return this.$store.state.MemberStore.local_member_setting;

      }else{
        return this.$store.state.MemberStore.local_member_setting;

      }

      
    },
    membershipRegistrationTotal: function() {
      return (
        Number(this.selectedSetting.number_of_persons) +
        Number(this.selectedSetting.number_of_children)
      );
    },
    allMembers: function() {
      return this.$store.state.MemberStore.all_members;
    },
    corporateMembers: function() {
      return this.$store.state.MemberStore.corporate_members;
    },
    bookingMembers: function() {
      let allmembers = this.$store.state.MemberStore.all_members.concat(
        this.$store.state.MemberStore.corporate_members
      );
      return allmembers;
    },
    singleMember: function() {
      return this.$store.state.MemberStore.member;
    },
    singleCorporateMember: function() {
      return this.$store.state.CorporateMemberStore.corporate_member;
    },
    allMemberVisits: function() {
      return this.$store.state.MemberStore.member_visits;
    },

    updateMember: function() {
      if (this.$route.name === "Member") {
        this.member.member_setting = this.$store.state.MemberStore.member.setting_public_id;
        this.member.residence = this.$store.state.MemberStore.member.residence_public_id;
        this.member.household_type = this.$store.state.MemberStore.member.household_type_public_id;
        this.member.registration_type = this.$store.state.MemberStore.member.registration_type_public_id;
        this.member.first_name = this.$store.state.MemberStore.member.first_name;
        this.member.sur_name = this.$store.state.MemberStore.member.surname;
        this.member.title = this.$store.state.MemberStore.member.title;
        this.member.postal_address = this.$store.state.MemberStore.member.postal_address;
        this.member.gender_id = this.$store.state.MemberStore.member.gender_public_id;
        this.member.dob = this.$moment(
          this.$store.state.MemberStore.member.dob
        ).format("YYYY-MM-DD");
        if (this.$store.state.MemberStore.member.expiry_date) {
          this.member.expiry_date = this.$moment(
            this.$store.state.MemberStore.member.expiry_date
          ).format("YYYY-MM-DD");
        } else {
          this.member.expiry_date = "";
        }
        this.member.postal_code = this.$store.state.MemberStore.member.postal_code;
        this.member.id_alien_number = this.$store.state.MemberStore.member.id_alien_number;
        this.member.email = this.$store.state.MemberStore.member.email;
        this.member.tel_number = this.$store.state.MemberStore.member.tel_number;
        this.member.member_id = this.$store.state.MemberStore.member.member_id;
        this.member.payment_method = this.$store.state.MemberStore.member.payment_method;
        this.member.salesforce_uuid = this.$store.state.MemberStore.member.salesforce_membership_uuid;
        this.member.salesforce_account_uuid = this.$store.state.MemberStore.member.salesforce_account_uuid;
        this.member.salesforce_contact_uuid = this.$store.state.MemberStore.member.salesforce_contact_uuid;
        this.member.payment_status = this.$store.state.MemberStore.member.payment_status;
      }
    },
    updateCorporateMember: function() {
      if (this.$route.name === "Corporate") {
        this.member.member_id = this.$store.state.CorporateMemberStore.corporate_member.memberID;
        this.member.company_name = this.$store.state.CorporateMemberStore.corporate_member.company_name;
        this.member.email = this.$store.state.CorporateMemberStore.corporate_member.email;
        this.member.email1 = this.$store.state.CorporateMemberStore.corporate_member.email1;
        this.member.email2= this.$store.state.CorporateMemberStore.corporate_member.email2;
        this.member.phone_number = this.$store.state.CorporateMemberStore.corporate_member.phone_number;
        this.member.contact_person_name = this.$store.state.CorporateMemberStore.corporate_member.contact_person_name;
        this.member.contact_person_phone_number = this.$store.state.CorporateMemberStore.corporate_member.contact_person_phone_number;
        this.member.postal_address = this.$store.state.CorporateMemberStore.corporate_member.postal_address;
        this.member.postal_code = this.$store.state.CorporateMemberStore.corporate_member.postal_code;

        if (
          this.$store.state.CorporateMemberStore.corporate_member.expiry_date
        ) {
          this.member.expiry_date = this.$moment(
            this.$store.state.CorporateMemberStore.corporate_member.expiry_date
          ).format("YYYY-MM-DD");
        } else {
          this.member.expiry_date = "";
        }
        this.member.payment_status = this.$store.state.CorporateMemberStore.corporate_member.payment_status;
        this.member.payment_method = this.$store.state.CorporateMemberStore.corporate_member.payment_method;
        this.member.amount = this.$store.state.CorporateMemberStore.corporate_member.amount;
        this.member.town = this.$store.state.CorporateMemberStore.corporate_member.town;
        this.member.country = this.$store.state.CorporateMemberStore.corporate_member.country;
        this.member.code = this.$store.state.CorporateMemberStore.corporate_member.code;
        this.member.passengers = this.$store.state.CorporateMemberStore.corporate_member.passengers;
        this.member.vehicles = this.$store.state.CorporateMemberStore.corporate_member.vehicles;
        this.member.visits = this.$store.state.CorporateMemberStore.corporate_member.visits;
        this.member.salesforce_uuid = this.$store.state.CorporateMemberStore.corporate_member.salesforce_uuid;
        this.member.salesforce_account_uuid = this.$store.state.CorporateMemberStore.corporate_member.salesforce_account_uuid;
        this.member.salesforce_contact_uuid = this.$store.state.CorporateMemberStore.corporate_member.salesforce_contact_uuid;
      }
    },
    $JengaAuth: function() {
      return this.$store.state.PaymentMethodStore.jenga_auth;
    }
  },
  mixins: [CurrencyConversion]
};
